import React, { useCallback, useEffect, useRef, useState } from 'react';
import { UserGroupIcon, CursorArrowRippleIcon, ArrowLeftStartOnRectangleIcon, ChevronUpDownIcon, CheckIcon, ArrowUpIcon, ArrowDownIcon } from '@heroicons/react/24/outline'
import Layout from '../../Layout/Layout';
import 'react-quill/dist/quill.snow.css';
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react';
import Datepicker from 'react-tailwindcss-datepicker';
import Chart from 'react-google-charts';
import UserFilterComponent from '../../../base/UserFilterComponent';
import { userService } from '../../../apiService/user.service';
import categoryData from '../../../apiService/category.service';
import { authorService } from '../../../apiService/author.service';
import { devicePlatformService } from '../../../apiService/device.service';
import { capitalizeFirstLetter, convertDateToFormat, formatNumber, toObject, transformData, transformDataForUserType, validateDates } from '../../utils/utils';
import { userTypeService } from '../../../apiService/usertype.service';
import { getPreviousDate } from '../../utils/dateFormate';
import DefaultUser from '../../base/DefaultUser';
import toast, { Toaster } from 'react-hot-toast';
import { Link } from 'react-router-dom';
import BaseTable from '../../../base/BaseTable';
import LoadingSpinner from '../../../base/Loading/Loading';
import { DOMAIN_ID, DOMAIN_NAME } from '../../../apiService/constant/domainkey';
import { registerUserService } from '../../../apiService/register.user.service';
import { formatDateToYYYYMMDD } from '../../utils/formatDateToYYYYMMDD';


const stats = [
  {
    id: 1,
    name: "Page Visits",
    subname: "All Users",
    stat: "0",
    substat: "0",
    icon: UserGroupIcon,
    change: "0",
    changeType: "positive",
    bg: "bg-red-50",
    iconcolor: "text-red-500",
  },
  {
    id: 2,
    name: "Unique Users",
    subname: "Unique Users",
    stat: "0",
    substat: "0",
    icon: ArrowLeftStartOnRectangleIcon,
    change: "0",
    changeType: "positive",
    bg: "bg-purple-50",
    iconcolor: "text-purple-500",
  },
  {
    id: 3,
    name: "New Users",
    subname: "All Piano Users",
    stat: "0",
    substat: "0",
    icon: CursorArrowRippleIcon,
    change: "0",
    changeType: "negative",
    bg: "bg-green-50",
    iconcolor: "text-green-500",
  },
  {
    id: 4,
    name: "Returning Users",
    subname: "All SSO Users",
    stat: "0",
    substat: "0",
    icon: ArrowLeftStartOnRectangleIcon,
    change: "0",
    changeType: "positive",
    bg: "bg-purple-50",
    iconcolor: "text-purple-500",
  },
];

// const domainlist = [
//     { id: "0", name: "HZ - Hindi", value: "hindi-herzindagi.com" },
//     { id: "1", name: "HZ - English", value: "english-herzindagi.com" },
//     { id: "2", name: "HZ - Tamil", value: "tamil-herzindagi.com" },
//     { id: "3", name: "Jagran", value: "jagran.com" },
// ];



export const SignInMethodData = [
    ["Total", "Total Users"],
    ["google", 85974],
    ["mobile", 59727],
];

export const UserMethodData = [
    ["Total", "Total Users"],
    ["Casual", 85974],
    ["Loyal", 59727],
    ["Brand", 29720],
];

export const PieHoleOption = {
    pieHole: 0.56,
    is3D: false,
    legend: 'none',
    chartArea: {
        left: 10,
        right: 10, // !!! works !!!
        bottom: 20,  // !!! works !!!
        top: 20,
        width: "100%",
        height: "100%"
    }
};

const domainlist = Object.keys(DOMAIN_NAME).map((key, index) => ({
    id: index.toString(),
    name: key.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
    value: key,
    apiKey: DOMAIN_NAME[key],
    product_id: DOMAIN_ID[key]
}));

export default function Registered() {
    const [selectedDomain, setSelectedDomain] = useState(domainlist[0]);
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [openFilter, setOpenFilter] = useState(false);
    const [authListData, setAuthorListData] = useState([]);
    const [isAuthorLoading, setIsAuthorLoading] = useState(false);
    const [isPlatformLoading, setIsPlatformLoading] = useState();
    const [platformData, setPlatformData] = useState();
    const [usertype, setUserType] = useState([]);
    const [isUserTypeLoading, setIsUserTypeLoading] = useState(false);
    const [userTypeData, setUserTypeData] = useState();
    const [userInfo, setUserInfo] = useState(stats)
    const [isLoadingUserInfo, setLoadingUserInfo] = useState(false)
    const initialized = useRef(false)
    const [dateValue, setDateValue] = useState({
        startDate: null,
        endDate: null,
    });
    const [listPlatform, setListPlatform] = useState([])
    const [isCategoryEmpty, setCategoryEmpty] = useState(false)
    const [isAuthorEmpty, setAuthorEmpty] = useState(false)
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(5)

    console.log("this is the selected domain");
    

    const getUserInfo = async (date, domain) => {
        setLoadingUserInfo(true);
        const registered = true;
        try {
            // const result = await registerUserService(domain?.product_id ? domain?.product_id : domainlist[0]?.product_id,dateValue?.startDate ? convertDateToFormat(dateValue.startDate) : getPreviousDate(), dateValue?.endDate);
            const response = await userService(
                domain?.value ? domain?.value : selectedDomain.value, 
                date ? date : getPreviousDate(),
                registered,
                {},
                domain?.apiKey ? domain?.apiKey : selectedDomain?.apiKey 
            );
            const nameToResponseField = {
              "Page Visits": "pageViews",
              "Unique Users": "uniqueUsers",

              "New Users": "newUsers",
              "Returning Users": "returningUsers",
            };
            const statUpdate = stats?.map(item => {
                const responseField = nameToResponseField[item?.name];
                
                if (responseField) {
                    return {
                        ...item,
                        stat: response?.[responseField],
                        substat: response?.[responseField],
                    };
                }
                return item;
            });
                
            setUserInfo(statUpdate);
        } catch (error) {
            console.error("Error", error);
        } finally {
            setLoadingUserInfo(false);
        }
    };


    useEffect(() => {
        if (!initialized.current) {
            initialized.current = true
            run()
        }
    }, [])


    const run = (date=getPreviousDate(), domain) => {
        
        getUserInfo(date, domain);
        category(date, domain);
        authorList(date, domain);
        devicePlatform(date, domain);
        userType(date, domain);
    };

    const category = useCallback(async (date, domain) => {
        setLoading(true);
        let limit = 8;
        try {
            const response = await categoryData(
                domain?.value ? domain?.value : selectedDomain.value, // Use domain.value
                date,
                limit,
                page,
                { isRegistered: true },
                domain?.apiKey ? domain?.apiKey : selectedDomain.apiKey  // Use domain.apiKey
            );
            setCategories(response?.data?.categoryList);
            setCategoryEmpty(response?.data?.categoryList.length < 1);
            setLoading(false);
        } catch (error) {
            console.error("Error category", error);
            setCategories([]);
            setLoading(false);
        }
    }, [page]);

    const authorList = useCallback(async (date, domain) => {
        setIsAuthorLoading(true);
        try {
            const authList = await authorService(
                domain?.value ? domain?.value : selectedDomain.value, // Use domain.value
                date,
                limit,
                page,
                { isRegistered: true },
                domain?.apiKey ? domain?.apiKey : selectedDomain.apiKey  // Use domain.apiKey
            );
            setAuthorListData(authList.authorsList);
            setAuthorEmpty(authList.authorsList?.length < 1);
            setIsAuthorLoading(false);
        } catch (error) {
            setAuthorListData([]);
            console.log(error);
            setIsAuthorLoading(false);
        }
    }, [page, limit]);

    const devicePlatform = useCallback(async (date, domain) => {
        setIsPlatformLoading(true);
        let isRegistered = true;
        let limit = 5;
        try {
            const response = await devicePlatformService(
                domain?.value ? domain?.value : selectedDomain.value, 
                date,
                limit,
                page,
                isRegistered,
                domain?.apiKey ? domain?.apiKey : selectedDomain.apiKey  // Use domain.apiKey
            );
            setPlatformData(transformData(response?.deviceCount));
            setListPlatform(response?.deviceCount);
            setIsPlatformLoading(false);
        } catch (error) {
            console.error("Error devicePlatform", error);
        } finally {
            setIsPlatformLoading(false);
        }
    }, [page]);

    const userType = useCallback(async (date, domain) => {
        
        setIsUserTypeLoading(true);
        let limit = 5;
        let isRegistered = true;
        try {
            
            const response = await userTypeService(
                domain?.value ? domain?.value : selectedDomain.value, 
                date,
                limit,
                page,
                isRegistered,
                domain?.apiKey ? domain?.apiKey : selectedDomain.apiKey
            );

             const data = response?.userList[0];
            
            const SignInMethodData = [
                ["Total", "Total Users"],
                ["casual", data?.casual],
                ["loyal", data?.loyal],
                ["brandLovers", data?.brandLovers],
                ["totalCount", data?.totalCount]
            ];

            
            
            setUserType(SignInMethodData)
            
            
      setUserTypeData(response?.result);
            } catch (error) {
            setUserType([]);
            console.error("Error userType", error);
        } finally {
            console.log("exc")
            setIsUserTypeLoading(false);
        }
    }, []);




    const onFilterApply = () => {
        if (dateValue.startDate) {
            setAuthorListData([]);
            setCategories([])
            run(convertDateToFormat(dateValue.startDate), selectedDomain?.value,)
        }

    }

    const onDateSelect = (date) => {
        let isValidDate;
        if (date.startDate !== null) {
            isValidDate = validateDates(convertDateToFormat(date.startDate))
        }

        if (isValidDate?.isValid === true) {
            setDateValue(date)
        } else if (isValidDate?.isValid === false) {
            return toast.error(isValidDate?.message)
        }
    }

    const onDomainSelect = (data) => {
        const currentDate = dateValue.startDate
            ? convertDateToFormat(dateValue.startDate)
            : convertDateToFormat(getPreviousDate());
    
        const newDomain = { ...data, apiKey: DOMAIN_NAME[data?.value] , product_id:DOMAIN_ID[data?.value] };
        setSelectedDomain(newDomain); // Update state
        setLoading(true);
        setIsAuthorLoading(true);

        
    
        run(currentDate, newDomain); // Pass the new domain object immediately
    
        setLoading(false);
        setIsAuthorLoading(false);
    };

    const renderPlatform = () => {
        return (
            <div className="grid grid-cols-1 lg:grid-cols-3">
                <div className="flex justify-center items-center">
                    <ul
                        className="divide-y divide-gray-100 w-full pl-10"
                    >
                        {
                            listPlatform?.map((item, index) => {
                                return (
                                  <li className="flex justify-between gap-x-6 py-5 pt-0">
                                    <div className="min-w-0 mt-4">
                                      <p className="text-xs/5 font-semibold text-gray-400">
                                        {capitalizeFirstLetter(
                                          item?.deviceType
                                        )}
                                      </p>
                                      <p className="mt-1 truncate text-3xl font-bold text-gray-700 mb-2">
                                        {formatNumber(item?.count || 0)}
                                      </p>
                                      <div className="text-xs">
                                        {/* <span className="w-4 h-4 mr-1 bg-green-100 rounded-full inline-flex items-center justify-center">
                                        <ArrowUpIcon
                                            aria-hidden="true"
                                            className="size-2 text-green-700"
                                        />
                                    </span> */}
                                        <span className="text-green-600">
                                          {item?.percentage} (
                                          {item.percentageChange})
                                        </span>{" "}
                                        {/* than last week */}
                                      </div>
                                    </div>
                                  </li>
                                );
                            })
                        }

                    </ul>
                </div>
                <div className="flex justify-center col-span-2 py-4">
                    <Chart
                        chartType="PieChart"
                        width="100%"
                        height="300px"
                        data={platformData}
                        options={PieHoleOption}
                    />
                </div>
            </div>
        )
    }

    const renderCategory = [
      {
        key: "category",
        label: "Category",
        className:
          "py-3.5 pl-8 pr-3 text-left text-sm font-semibold text-gray-900",
        render: (row) => (
          <Link
            className="text-red-600 hover:text-red-700"
            state={{
              category: row.category,
              domain: row.reqDomain,
              isRegistered: true,
              apiKey: selectedDomain?.apiKey
            }}
            to={{
              pathname: `/cdp/anonymous/categories`,
            }}
          >
            {capitalizeFirstLetter(row.category || "")}
          </Link>
        ),
      },
      {
        key: "pageView",
        label: "PV",
        className: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
      },
      {
        key: "uniqueUsers",
        label: "User",
        className: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
      },
      {
        key: "newUsers",
        label: "New Users",
        className: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
      },
      {
        key: "returningUsers",
        label: "Returning Users",
        className: "px-3 py-3.5 text-left text-xs font-semibold text-gray-900",
      },
    ];

    const renderAuthor = [
      {
        key: "author",
        label: "Name",
        className:
          "py-3.5 pl-8 pr-3 text-left text-sm font-semibold text-gray-900",
        render: (row) => (
          <div className="flex items-center">
            <div className="size-11 shrink-0">
              {row.image ? (
                <img
                  alt=""
                  src={row.image || ""}
                  className="size-11 rounded-full"
                />
              ) : (
                <DefaultUser />
              )}
            </div>
            <div className="ml-4">
              <div className="font-medium text-gray-900">
                <Link
                  state={{
                    author: row?.author,
                    authorId: row?.authorId,
                    domain: row?.reqDomain,
                    isRegistered: true,
                    apiKey: selectedDomain?.apiKey
                  }}
                  to={{
                    pathname: `/cdp/anonymous/articles`,
                  }}
                  className="text-red-600 hover:text-red-700"
                >
                  {row?.author}
                </Link>
              </div>
              {row.email && (
                <div className="mt-1 text-gray-500 text-xs">{row.email}</div>
              )}
            </div>
          </div>
        ),
      },
      {
        key: "pageView",
        label: "PV",
        className: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
      },
      {
        key: "uniqueUsers",
        label: "User",
        className: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
      },
      {
        key: "newUsers",
        label: "New Users",
        className: "px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
      },
      {
        key: "returningUsers",
        label: "Returning Users",
        className: "px-3 py-3.5 text-left text-xs font-semibold text-gray-900",
      },
    ];
    

    return (
      <Layout>
        <main>
          <div className="mx-auto max-w-7xl my-6 px-4 lg:px-0">
            <div className="flex justify-center mb-6">
              <nav className="flex divide-x divide-gray-200 rounded-lg shadow overflow-hidden">
                <a
                  href="/cdp/anonymous"
                  className="text-gray-500 hover:text-gray-500 group relative min-w-0 flex-1 overflow-hidden bg-gray-50 hover:bg-gray-100 px-8 py-4 text-center text-sm font-bold uppercase focus:z-10"
                >
                  <span>Anonymous</span>
                  <span
                    aria-hidden="true"
                    className="absolute inset-x-0 bottom-0 h-0.5"
                  />
                </a>
                <a
                  href="/cdp/anonymous/registered"
                  className="text-gray-50 hover:text-gray-50 group relative min-w-0 flex-1 overflow-hidden bg-red-500 hover:bg-red-600 px-8 py-4 text-center text-sm font-bold uppercase focus:z-10"
                >
                  <span>Registered</span>
                  <span
                    aria-hidden="true"
                    className="bg-red-500 absolute inset-x-0 bottom-0 h-0.5"
                  />
                </a>
              </nav>
            </div>
            <UserFilterComponent
              title="Registered User"
              selectedDomain={selectedDomain}
              onDomainSelect={onDomainSelect}
              domainlist={domainlist}
              dateValue={dateValue}
              onDateSelect={onDateSelect}
              onFilterApply={onFilterApply}
              userInfo={userInfo}
            />
          </div>

          <div className="mx-auto max-w-7xl my-6 px-4 lg:px-0">
            <div className="grid gap-6 grid-cols-1 lg:grid-cols-2">
              <BaseTable
                title="Categories"
                columns={renderCategory}
                data={categories}
                loading={loading}
                isEmptyMessage="No categories found"
              />

              <BaseTable
                title="Top Authors"
                columns={renderAuthor}
                data={authListData}
                loading={isAuthorLoading}
                isEmptyMessage="No Author found"
              />

              <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
                <div className="mx-auto">
                  <div className="rounded-sm shadow bg-white">
                    <div className="px-8 py-6 flex flex-wrap lg:flex-nowrap items-center md:justify-between border-b border-gray-200">
                      <div className="min-w-full lg:min-w-0 flex-1 mb-4 lg:mb-0">
                        <h2 className="text-lg font-bold text-gray-900 sm:truncate sm:text-2xl sm:tracking-tight">
                          Platform
                        </h2>
                      </div>
                    </div>
                    {isPlatformLoading ? (
                      <tr>
                        <td colSpan="5" className="py-4">
                          <LoadingSpinner />
                        </td>
                      </tr>
                    ) : (
                      <>{renderPlatform()}</>
                    )}
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
                <div className="mx-auto">
                  <div className="rounded-sm shadow bg-white">
                    <div className="px-8 py-6 flex flex-wrap lg:flex-nowrap items-center md:justify-between border-b border-gray-200">
                      <div className="min-w-full lg:min-w-0 flex-1 mb-4 lg:mb-0">
                        <h2 className="text-lg font-bold text-gray-900 sm:truncate sm:text-2xl sm:tracking-tight">
                          User Types
                        </h2>
                      </div>
                    </div>
                    {isUserTypeLoading ? (
                      <LoadingSpinner />
                    ) : (
                      <div className="grid grid-cols-1 lg:grid-cols-3">
                        <div className="flex justify-center items-center">
                          <ul
                            role="list"
                            className="divide-y divide-gray-100 w-full pl-10"
                          >
                            <li className="flex justify-between gap-x-6 py-5 pt-0">
                              <div className="min-w-0">
                                <p className="text-sm/5 font-semibold text-gray-700 flex items-center">
                                  <span className="w-2 h-2 rounded-full bg-red-500 flex mr-2"></span>
                                  <span>Casual</span>
                                </p>
                                {userTypeData?.casualPercentageIncrease && (
                                  <p className="truncate text-xs font-bold text-gray-400 ml-4">
                                    {Number(
                                      userTypeData?.casualPercentageIncrease
                                    ) > 0
                                      ? `Increase ${userTypeData.casualPercentageIncrease}%`
                                      : `Decrease ${userTypeData.casualPercentageIncrease}%`}
                                  </p>
                                )}
                              </div>
                              <div className="min-w-0">
                                <p className="text-sm/5 font-semibold text-gray-700">
                                  {/* {userTypeData}  */}
                                  {userTypeData
                                    ? formatNumber(userTypeData?.casual || 0)
                                    : ""}
                                </p>
                              </div>
                            </li>
                            <li className="flex justify-between gap-x-6 py-5 pt-0">
                              <div className="min-w-0">
                                <p className="text-sm/5 font-semibold text-gray-700 flex items-center">
                                  <span className="w-2 h-2 rounded-full bg-green-500 flex mr-2"></span>
                                  <span>Loyal</span>
                                </p>
                                {userTypeData?.loyalPercentageIncrease && (
                                  <p className="truncate text-xs font-bold text-gray-400 ml-4">
                                    {Number(
                                      userTypeData?.loyalPercentageIncrease
                                    ) > 0
                                      ? `Increase ${userTypeData.loyalPercentageIncrease}%`
                                      : `Decrease ${userTypeData.loyalPercentageIncrease}%`}
                                  </p>
                                )}
                              </div>
                              <div className="min-w-0">
                                <p className="text-sm/5 font-semibold text-gray-700">
                                  {userTypeData
                                    ? formatNumber(userTypeData?.loyal || 0)
                                    : ""}
                                </p>
                              </div>
                            </li>
                            <li className="flex justify-between gap-x-6 py-5 pt-0">
                              <div className="min-w-0">
                                <p className="text-sm/5 font-semibold text-gray-700 flex items-center">
                                  <span className="w-2 h-2 rounded-full bg-purple-500 flex mr-2"></span>
                                  <span>Brand Lover</span>
                                </p>
                                {userTypeData?.brandLoversPercentageIncrease && (
                                  <p className="truncate text-xs font-bold text-gray-400 ml-4">
                                    {Number(
                                      userTypeData?.brandLoversPercentageIncrease
                                    ) > 0
                                      ? `Increase ${userTypeData.brandLoversPercentageIncrease}%`
                                      : `Decrease ${userTypeData.brandLoversPercentageIncrease}%`}
                                  </p>
                                )}
                              </div>
                              <div className="min-w-0">
                                <p className="text-sm/5 font-semibold text-gray-700">
                                  {userTypeData
                                    ? formatNumber(
                                        userTypeData?.brandLovers || 0
                                      )
                                    : ""}
                                </p>
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div className="flex justify-center col-span-2 py-4">
                          <Chart
                            chartType="PieChart"
                            width="100%"
                            height="300px"
                            data={usertype}
                            options={PieHoleOption}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
        <Toaster />
      </Layout>
    );
}
